import PageTemplate from "../components/common/PageTemplate";
import ChangeAddress from "../screen/locationAddress/ChangeAddress";

const ChangeAddressPage = () => {
  return (
    <PageTemplate mainComponent={<ChangeAddress />} header="Edit Alamat" />
  );
};

export default ChangeAddressPage;
